module.exports = __webpack_public_path__ + "img/altmuehlfranken_logo.c8a4d30.png";